import React from "react";

export default function OrderDetailsShimmer() {
  return (
    <div className="container-fluid">
      <div className="row">
        {/* LEFT: TABLE SHIMMER */}
        <div className="col-lg-8">
          <div className="card">
            <div className="card-body p-2">
              <table className="table table-centered mb-0">
                <thead>
                  <tr>
                    <th>
                      <span className="placeholder col-2"></span>
                    </th>
                    <th>
                      <span className="placeholder col-3"></span>
                    </th>
                    <th>
                      <span className="placeholder col-5"></span>
                    </th>
                    <th>
                      <span className="placeholder col-2"></span>
                    </th>
                    <th>
                      <span className="placeholder col-2"></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(5)].map((_, i) => (
                    <tr key={i}>
                      <td>
                        <span className="placeholder col-2"></span>
                      </td>
                      <td>
                        <span className="placeholder col-3"></span>
                      </td>
                      <td>
                        <span className="placeholder col-5"></span>
                      </td>
                      <td>
                        <span className="placeholder col-2"></span>
                      </td>
                      <td>
                        <span className="placeholder col-2"></span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* RIGHT: INFO & BUTTONS SHIMMER */}
        <div className="col-4 stick">
          <div className="card">
            <div className="card-body p-2">
              {[...Array(5)].map((_, i) => (
                <p key={i} className="placeholder-glow mb-2">
                  <span className="placeholder col-12"></span>
                </p>
              ))}
            </div>
          </div>
          <div className="mt-3">
            <p className="placeholder-glow">
              <span
                className="placeholder col-12"
                style={{ height: "40px" }}
              ></span>
            </p>
            <p className="placeholder-glow">
              <span
                className="placeholder col-12"
                style={{ height: "40px" }}
              ></span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
